import React, { useState, useEffect } from "react";
import Preloader from "../../../components/Preloader/Preloader";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import ButtonComponent from 'react-button-component';
import LoadingOverlay from 'react-loading-overlay';
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
const useStyles = makeStyles((theme) => ({
	btnSearch: {
        marginTop: 30,
        backgroundColor: "green",
	},
    modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
    paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
    field: {
		width: "100%",
		marginBottom: "1rem"
	},
}));
const PackageSalesSummary = (props) => {
    const classes = useStyles();
    const [nextPagePath, setNextPagePath] = useState("");
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
    const [idnoselected, setIdnoSelected] = useState("");
    const [eligibleforrelease, setEligibleRel] = useState("");
    const [isFS, setIfFS] = useState("");
    const [isLoaded, setisLoaded] = useState();
    const [releaseidno, setReleaseIdno] = useState("");
    const [selectedpackagetype, setSelectedPackageType] = useState("");

    //Dropdown Filter
    const [hideDate, sethideDate] = useState(true);
    const [hideIdno, sethideIdno] = useState(false);
    const [hideRelStatus, sethideRelStatus] = useState(false);
    const [hideSoldto, sethideSoldto] = useState(false);
    const [hideActType, sethideActType] = useState(false);
    const [hideCountry, sethideCountry] = useState(false);
    const [hideDelTarget, sethideDelTarget] = useState(false);
    const [hidePackage, sethidePackage] = useState(false);
    const [hidePromo, sethidePromo] = useState(false);
    const [hidePackStatus, sethidePackStatus] = useState(false);
    //Dropdown Filter
    const min_releasedate = '2021-04-01';
	const nextpage =  {
		// pathname: "/package-sales-payment",
		pathname: nextPagePath,
		idno: idnoselected,
        eligibleforrelease: eligibleforrelease,
        isfs:isFS
	}
    const nextpageEncoding =  {
        isCORelease:"yes"
	}
    const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
    };
	//ApiData Component useState SOF
    const get_accttype = () => {
        setisLoaded(true);
		//get data for warehouse/location dropdown
        const formData = new FormData();
        formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL + "accttypelist";
		axios.post(apiUrl, formData, {headers:headers}).then(res => {
			loadAccttype(res.data.accttype);
		});
	};

	const get_country = () => {
		//get data for shipping location dropdown
        const formData = new FormData();
        formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL + "countrylist";
		axios.post(apiUrl, formData, {headers:headers}).then(res => {
			loadCountry(res.data.country);
		});
	};

	const get_promocode = () => {
		//get data for shipping location dropdown
        const formData = new FormData();
        formData.append('form_data', "");
		const apiUrl = process.env.REACT_APP_API_URL + "promocodelist";
		axios.post(apiUrl, formData, {headers:headers}).then(res => {
			loadPromocode(res.data.promocode);
		});
	};

    const get_packageavailed = () => {
        //get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'packageavailedlist';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            loadPackageAvailed(res.data.packageavailed);
		});
	};

    const package_sales_summary = () => {
        setisLoaded(false);
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
            prep_data: prep_data
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'packagesalessummary';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            loadPackageSalesList(res.data);
		});
	};

    const releasepackage = (idno) => {
        // setShowOverlay(true);
        // setOverlayMsg('Processing Release...');
		// //get data for warehouse/location dropdown
		// const form_data = {
        //     hqidno: branchIdNo,
		// 	idno: idno
		// }
        // const formData = new FormData();
        // formData.append('form_data', JSON.stringify(form_data));
		// const apiUrl = process.env.REACT_APP_API_URL+'releasepackage';
		// axios.post(apiUrl, formData, {headers:headers}).then((res) => {
        //     if(res.data.result.success == 1){
		// 		setShowMsgBox(true);
		// 		setMsg(res.data.result.message);
		// 		setMsgType("success");
		// 		setTimeout(() => {
        //             setShowOverlay(false);
        //             setOverlayMsg('');
		// 			setShowMsgBox(false);
        //             package_sales_summary();
		// 		}, 3000)
		// 	}else{
		// 		setShowMsgBox(true);
		// 		setMsg(res.data.result.message);
		// 		setMsgType("warning");
		// 		setTimeout(() => {
		// 			setShowMsgBox(false);
		// 		}, 3000)
		// 	}
		// });
	};

    const get_codesonly_details = (idno, packagetype) => {
        setShowOverlay(true);
        setOverlayMsg('Fetching Data...');
		//get data for warehouse/location dropdown
		const form_data = {
			idno: idno,
            packagetype:packagetype
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'getcodesonlyencodingdetails';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
                nextpageEncoding['pageInfo']= (res.data.pageInfo);
                nextpageEncoding['transactionInfo']= (res.data.transactionInfo);
                proceedtoencoding();
		});
	};
	//ApiData Component useState EOF
	const [accttype_dropdown, loadAccttype] = useState([]);
    const [country_dropdown, loadCountry] = useState([]);
    const [promocode_dropdown, loadPromocode] = useState([]);
    const [packageavailed_dropdown, loadPackageAvailed] = useState([]);
    
    const selectAccttypeProps = {
		options: accttype_dropdown,
		getOptionLabel: option => option.atype
	};

	const selectCountryProps = {
		options: country_dropdown,
		getOptionLabel: option => option.countryname
	};

	const selectPromocodeProps = {
		options: promocode_dropdown,
		getOptionLabel: option => option.nav_name
	};

    const selectPackageAvailedProps = {
		options: packageavailed_dropdown,
		getOptionLabel: option => option.description
	};
    
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF

	//Table Settings
	const [TABLE_DATA, loadDataTable] = useState([]);
	const [selectedPackage, setSelectedPackage] = useState({});

	const loadPackageSalesList = (data) => {
        refreshTable();
		const newData = [...TABLE_DATA];
		for (let i=0;i < data.packagesalessummary.length;i++) {
            if(data.rawpackagesalessummary[i].status==1 || data.rawpackagesalessummary[i].status==8 
                || data.rawpackagesalessummary[i].status==2 
                || data.rawpackagesalessummary[i].status==3 || data.rawpackagesalessummary[i].status==6)
			{
                if(data.rawpackagesalessummary[i].releaseddate == '0000-00-00' && data.rawpackagesalessummary[i].date >= min_releasedate){
                    const tempObj = {trandate:data.packagesalessummary[i][0], soldto:data.packagesalessummary[i][1], idno:data.packagesalessummary[i][2], amount:data.packagesalessummary[i][3], packagetype:data.packagesalessummary[i][4],  atype:data.packagesalessummary[i][5], 
                                    action:<Grid container spacing={2}>
                                                   {/* <Grid item xs={12} sm={12} xl={12}>
                                                    <Button variant="contained" color="primary" onClick={(e) => {confirmrelease(data.packagesalessummary[i][2],data.rawpackagesalessummary[i].packageid,data.packagesalessummary[i][4])}}>Release</Button>
                                                </Grid> */}
                                                <Grid item xs={12} sm={12} xl={12}>
                                                    <Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(data.packagesalessummary[i][2], "yes", "")}}>View</Button>
                                                </Grid>
                                            </Grid>
                                    }
                    newData.push(tempObj);
                }else{
                    const tempObj = {trandate:data.packagesalessummary[i][0], soldto:data.packagesalessummary[i][1], idno:data.packagesalessummary[i][2], amount:data.packagesalessummary[i][3], packagetype:data.packagesalessummary[i][4],  atype:data.packagesalessummary[i][5], 
                        action:<Grid container spacing={2}>
                                    <Grid xs={12} sm={12}>
                                        <Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(data.packagesalessummary[i][2], "no", "")}}>View</Button>
                                    </Grid>
                                </Grid>
                        }
                    newData.push(tempObj);
                }
            }
            else if(data.rawpackagesalessummary[i].status==4)
            {   
                if(data.rawpackagesalessummary[i].packageid==-1)
                {
                    if(data.rawpackagesalessummary[i].releaseddate == '0000-00-00' && data.rawpackagesalessummary[i].date >= min_releasedate){
                        const tempObj = {trandate:data.packagesalessummary[i][0], soldto:data.packagesalessummary[i][1], idno:data.packagesalessummary[i][2], amount:data.packagesalessummary[i][3], packagetype:data.packagesalessummary[i][4],  atype:data.packagesalessummary[i][5], 
                                        action:<Grid container spacing={2}>
                                                      {/* <Grid item xs={12} sm={12} xl={12}>
                                                        <Button variant="contained" color="primary" onClick={(e) => {confirmrelease(data.packagesalessummary[i][2],data.rawpackagesalessummary[i].packageid,data.packagesalessummary[i][4])}}>Release</Button>
                                                    </Grid> */}
                                                    <Grid item xs={12} sm={12} xl={12}>
                                                        <Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(data.packagesalessummary[i][2], "yes", "")}}>View</Button>
                                                    </Grid>
                                               </Grid>
                                        }
                        newData.push(tempObj);
                    }else{
                        const tempObj = {trandate:data.packagesalessummary[i][0], soldto:data.packagesalessummary[i][1], idno:data.packagesalessummary[i][2], amount:data.packagesalessummary[i][3], packagetype:data.packagesalessummary[i][4],  atype:data.packagesalessummary[i][5], 
                            action:<Grid container spacing={2}>
                                        <Grid xs={12} sm={12}>
                                            <Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(data.packagesalessummary[i][2], "no", "")}}>View</Button>
                                        </Grid>
                                    </Grid>
                            }
                        newData.push(tempObj);
                    }
                }
                else
                {
                    if(data.rawpackagesalessummary[i].releaseddate == '0000-00-00' && data.rawpackagesalessummary[i].date >= min_releasedate){
                        const tempObj = {trandate:data.packagesalessummary[i][0], soldto:data.packagesalessummary[i][1], idno:data.packagesalessummary[i][2], amount:data.packagesalessummary[i][3], packagetype:data.packagesalessummary[i][4],  atype:data.packagesalessummary[i][5], 
                                        action:<Grid container spacing={2}>
                                                    {/* <Grid item xs={12} sm={12} xl={12}>
                                                        <Button variant="contained" color="primary" onClick={(e) => {confirmrelease(data.packagesalessummary[i][2],data.rawpackagesalessummary[i].packageid,data.packagesalessummary[i][4])}}>Release</Button>
                                                    </Grid> */}
                                                    <Grid item xs={12} sm={12} xl={12}>
                                                        <Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(data.packagesalessummary[i][2], "yes", "fs")}}>View</Button>
                                                    </Grid>
                                                </Grid>
                                        }
                        newData.push(tempObj);
                    }else{
                        const tempObj = {trandate:data.packagesalessummary[i][0], soldto:data.packagesalessummary[i][1], idno:data.packagesalessummary[i][2], amount:data.packagesalessummary[i][3], packagetype:data.packagesalessummary[i][4],  atype:data.packagesalessummary[i][5], 
                            action:<Grid container spacing={2}>
                                        <Grid xs={12} sm={12}>
                                            <Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(data.packagesalessummary[i][2], "yes", "fs")}}>View</Button>
                                        </Grid>
                                    </Grid>
                            }
                        newData.push(tempObj);
                    }
                }
            }
            else if(data.rawpackagesalessummary[i].status==5)
            {
                if(data.rawpackagesalessummary[i].releaseddate == '0000-00-00' && data.rawpackagesalessummary[i].date >= min_releasedate){
                    const tempObj = {trandate:data.packagesalessummary[i][0], soldto:data.packagesalessummary[i][1], idno:data.packagesalessummary[i][2], amount:data.packagesalessummary[i][3], packagetype:data.packagesalessummary[i][4],  atype:data.packagesalessummary[i][5], 
                                    action:<Grid container spacing={2}>
                                           {/* <Grid item xs={12} sm={12} xl={12}>
                                                    <Button variant="contained" color="primary" onClick={(e) => {confirmrelease(data.packagesalessummary[i][2],data.rawpackagesalessummary[i].packageid,data.packagesalessummary[i][4])}}>Release</Button>
                                                </Grid> */}
                                                <Grid item xs={12} sm={12} xl={12}>
                                                    <Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(data.packagesalessummary[i][2], "yes", "")}}>View</Button>
                                                </Grid>
                                            </Grid>
                                    }
                    newData.push(tempObj);                
                }else{
                    const tempObj = {trandate:data.packagesalessummary[i][0], soldto:data.packagesalessummary[i][1], idno:data.packagesalessummary[i][2], amount:data.packagesalessummary[i][3], packagetype:data.packagesalessummary[i][4],  atype:data.packagesalessummary[i][5], 
                        action:<Grid container spacing={2}>
                                    <Grid xs={12} sm={12}>
                                        <Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(data.packagesalessummary[i][2], "no", "")}}>View</Button>
                                    </Grid>
                                </Grid>
                        }
                    newData.push(tempObj);
                }
            }
        }
		loadDataTable([...newData]);
        setisLoaded(true);
	};
    
	const refreshTable = () => {
        TABLE_DATA.length = 0;
        const newData = [...TABLE_DATA];
		loadDataTable([...newData]);
	}

	const TABLE_COLUMNS = [
		{
		  name: 'trandate',
		  label: 'Date',
		}, {
		  name: 'soldto',
		  label: 'Sold To',
		}, {
            name: 'idno',
            label: 'ID No.',
        }, {
            name: 'amount',
            label: 'Amount',
        }, {
            name: 'packagetype',
            label: 'Package Type',
        }, {
            name: 'atype',
            label: 'Account Type',
        },  {
            name: 'action',
            label: 'Action',
            options: {
                // setCellProps: () => ({ style: { minWidth: "180px", maxWidth: "180px" }}),
                customBodyRender: (data, type, row) => {return <pre>{data}</pre>},
                filter: false,
                sort: false,
          },
        }
	];
	
	const TABLE_OPTION = {
        selectableRows: 'none',
        filter: false,
        download: false,
        print: false
    
	};
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
    const handleOpen2 = () => {
		setOpen2(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
    const handleClose2 = () => {
		setOpen2(false);
	};
	//Modal Settings EOF
    const formatDate = (date) => {
		let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;

		return [year, month, day].join('-');
	}
    //FormData
	const [prep_data, setData] = useState({"startDate":formatDate(new Date()),"endDate":formatDate(new Date())});
	//FormData EOF
	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
        isLoggedIn();
        get_packageavailed();
        // get_promocode();
        get_country();
        get_accttype();
        clearState();
    }, []);
    //OnLoad Event/Data Fetching SOF

    // Date Picker
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const startDateChanged = (e) => {
        setStartDate(e);
        const newData = {...prep_data};
        newData['startDate']= formatDate(e);
        setData({ ...newData });
    }
    const endDateChanged = (e) => {
        setEndDate(e);
        const newData = {...prep_data};
        newData['endDate']= formatDate(e);
        setData({ ...newData });
    }

    const viewpackagedetails = (idno, eligible, fs) => {
        setNextPagePath("/package-sales-summary-details");
        setIdnoSelected(idno);
        if(eligible == "yes"){
            setEligibleRel("yes");
        }else{
            setEligibleRel("");
        }
        if(fs == "fs"){
            setIfFS("fs");
        }else{
            setIfFS("");
        }
        proceedtopackagedetails();
    }

    const set_package_encoding = () => {
        nextpageEncoding['pathname'] = "/package-sales-information";
        get_codesonly_details(releaseidno, selectedpackagetype+"SET");
	}

    const cyop_encoding = () => {
        nextpageEncoding['pathname'] = "/package-sales-item";
        get_codesonly_details(releaseidno, selectedpackagetype+"CYOP");
	}

    useEffect(() => {
        props.history.push(nextpage);
    }, [nextPagePath]);

    const proceedtopackagedetails = () => {
        props.history.push(nextpage);
    }

    const proceedtoencoding = () => {
        props.history.push(nextpageEncoding);
    }

    const confirmrelease = (idno, packageid, packagetype) => {
        setReleaseIdno(idno);
        setSelectedPackageType(packagetype);
        if(packageid == 0){
            handleOpen2();
        }else{
            handleOpen();
        }
    }
    const prepData_initialState = {
        idno_filter: "",
        relstats_filter: "",
        soldto_filter: "",
        accttype_filter: "",
        country_filter: "",
        delivery_filter: "",
        package_filter: "",
        promo_filter: "",
        packstats_filter: "",
        startDate: formatDate(new Date()),
        endDate: formatDate(new Date())
    };

    const clearState = () => {
        setData({ ...prepData_initialState });
    };
    //Dropdown Filter Value
    const filterList = [
        { description: "Transaction Date", id: "date_filter" },
        { description: "IDNO", id: "idno_filter" },
        { description: "Release Status", id: "relstats_filter" },
        { description: "Sold To", id: "soldto_filter" },
        { description: "Activation Type", id: "accttype_filter" },
        { description: "Country", id: "country_filter" },
        { description: "Delivery Type", id: "delivery_filter" },
        { description: "Package Availed", id: "package_filter" },
        // { description: "Promo Code", id: "promo_filter" },
        // { description: "Package Status", id: "packstats_filter" },
    ];
    const releaseStatusList = [
        { description: "All", id: "" },
        { description: "For Release", id: 2 },
        { description: "Released", id: 1 }
    ];
    const deliveryList = [
        { description: "All", id: "" },
        { description: "Pick Up", id: 1 },
        { description: "Delivery", id: 2 },
        { description: "Toktok", id: 30 }
    ];
    const display_filters = (a,b,c,d,e,f,g,h,i,j) => {
        sethideDate(a);
        sethideIdno(b);
        sethideRelStatus(c);
        sethideSoldto(d);
        sethideActType(e);
        sethideCountry(f);
        sethideDelTarget(g);
        sethidePackage(h);
        sethidePromo(i);
        sethidePackStatus(j);
    }
    const clearStateSpecific = (nametoclear) => {
		const newData = { ...prep_data };
		newData[nametoclear] = "";
		setData({ ...newData });
	};  
    const onFilterChange = (selectedFilter) => {
        //clear prep_data value if not selected
        clearState();
        setStartDate(new Date());
        setEndDate(new Date());
        switch (selectedFilter) {
            case 'date_filter':
                display_filters(true,false,false,false,false,false,false,false,false,false);
                break;
            case 'idno_filter':
                display_filters(false,true,false,false,false,false,false,false,false,false);
                break;
            case 'relstats_filter':
                display_filters(true,false,true,false,false,false,false,false,false,false);
                break;
            case 'soldto_filter':
                display_filters(true,false,false,true,false,false,false,false,false,false);
                break;
            case 'accttype_filter':
                display_filters(true,false,false,false,true,false,false,false,false,false);
                break;
            case 'country_filter':
                display_filters(false,false,false,false,false,true,false,false,false,false);
                break;
            case 'delivery_filter':
                display_filters(true,false,false,false,false,false,true,false,false,false);
                break;
            case 'package_filter':
                display_filters(true,false,false,false,false,false,false,true,false,false);
                break;
            case 'promo_filter':
                display_filters(true,false,false,false,false,false,false,false,true,false);
                break;
            case 'packstats_filter':
                display_filters(true,false,false,false,false,false,true,true,true,true);
                break;    
        
            default:
                display_filters(true,false,false,false,false,false,false,false,false,false);
                break;
        }
    }

    const onInputChange = event => {
		const newData = { ...prep_data };
		newData[event.target.name] = event.target.value;
		setData({ ...newData });
	};  
    //Date Picker EOF
	return (
		<div className="page">
            <LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				{/* <Breadcrumbs aria-label="breadcrumb"> */}
                <NavLink to="/package-sales">
						<h4 className="header-title">Package Sales</h4>
					</NavLink>
                    <ArrowForwardIosIcon  fontSize="small" color="disabled"/>
					<h4>Package Sales Transaction History</h4>
				{/* </Breadcrumbs> */}
			</div>
            <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			<div className="page-container">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                autoComplete
                                options={filterList}
                                getOptionLabel={option => option.description}
                                includeInputInList
                                className={classes.autoComplete}
                                name="filterList"
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Filters"
                                        margin="normal"
                                        variant="outlined"
                                    />
                                )}
                                onChange={(event, newValue) => {
                                    if (
                                        !newValue == "" ||
                                        !newValue == null
                                    ) {
                                        onFilterChange(newValue.id);
                                    }
                                }}
                            />
                        </Grid>
                        <MuiPickersUtilsProvider
                            utils={DateFnsUtils}
                        >
                        { 
                        hideDate ?  
                        <Grid item xs={12} sm={3}>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                name="startDate"
                                label="From"
                                value={startDate}
                                inputVariant="outlined"
                                margin="normal"
                                required="true"
                                onChange={startDateChanged}
                                shouldCloseOnSelect={true}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </Grid>
                        :null}
                        { 
                        hideDate ?  
                        <Grid item xs={12} sm={3}>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="MM/dd/yyyy"
                                name="endDate"
                                label="To"
                                value={endDate}
                                inputVariant="outlined"
                                margin="normal"
                                required="true"
                                shouldCloseOnSelect={true}
                                onChange={endDateChanged}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                }}
                            />
                        </Grid>
                        :null}
                        </MuiPickersUtilsProvider>
                        { 
                        hideIdno ? 
                        <Grid item xs={12} sm={3}>
                            <TextField
                                name="idno_filter"
                                label="IDNO"
                                variant="outlined"
                                type="text"
                                margin="normal"
                                className={classes.field}
                                onChange={onInputChange}
                            />
                        </Grid>
                        :null}
                        { 
                        hideRelStatus ? 
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="relstats_filter"
                                autoComplete
                                options={releaseStatusList}
                                getOptionLabel={option => option.description}
                                includeInputInList
                                className={classes.autoComplete}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Release Status"
                                        margin="normal"
                                        variant="outlined"
                                    />
                                )}
                                onChange={async(event, newValue) => {
                                    if (
                                        !newValue == "" ||
                                        !newValue == null 
                                    ) {
                                        //code here
                                        const newData = {
                                            ...prep_data
                                        };
                                        newData["relstats_filter"] = newValue.id
                                        setData({ ...newData });
                                    }else{
                                        clearStateSpecific("relstats_filter");
                                    }
                                }}
                            />
                        </Grid>
                        :null}
                        { 
                        hideSoldto ? 
                        <Grid item xs={12} sm={3}>
                            <TextField
                                name="soldto_filter"
                                label="Sold To"
                                variant="outlined"
                                type="text"
                                margin="normal"
                                className={classes.field}
                                onChange={onInputChange}
                            />
                        </Grid>
                        :null}
                        { 
                        hideActType ? 
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                {...selectAccttypeProps}
                                autoComplete
                                includeInputInList
                                className={classes.autoComplete}
                                name="accttype_filter"
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Activation Type"
                                        margin="normal"
                                        variant="outlined"
                                        required="true"
                                    />
                                )}
                                onChange={async(event, newValue) => {
                                    if (
                                        !newValue == "" ||
                                        !newValue == null
                                    ) {
                                        const newData = {
                                            ...prep_data
                                        };
                                        newData["accttype_filter"] = newValue.atype;
                                        setData({ ...newData });
                                    }else{
                                        clearStateSpecific("accttype_filter");
                                    }
                                }}
                            />
                        </Grid>
                        :null}
                        {
                        hideCountry ? 
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                {...selectCountryProps}
                                autoComplete
                                includeInputInList
                                className={classes.autoComplete}
                                name="country_filter"
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Country"
                                        margin="normal"
                                        variant="outlined"
                                        required="true"
                                    />
                                )}
                                onChange={async(event, newValue) => {
                                    if (
                                        !newValue == "" ||
                                        !newValue == null
                                    ) {
                                        const newData = {
                                            ...prep_data
                                        };
                                        newData["country_filter"] = newValue.countryname;
                                        setData({ ...newData });
                                    }else{
                                        clearStateSpecific("country_filter");
                                    }
                                }}
                            />
                        </Grid>
                        :null}
                        {
                        hideDelTarget ? 
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="delivery_filter"
                                autoComplete
                                options={deliveryList}
                                getOptionLabel={option => option.description}
                                includeInputInList
                                className={classes.autoComplete}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Delivery Type"
                                        margin="normal"
                                        variant="outlined"
                                    />
                                )}
                                onChange={async(event, newValue) => {
                                    if (
                                        !newValue == "" ||
                                        !newValue == null
                                    ) {
                                        //code here
                                        const newData = {
                                            ...prep_data
                                        };
                                        newData["delivery_filter"] =
                                            JSON.stringify(
                                                newValue.id,
                                                null,
                                                " "
                                            );
                                        setData({ ...newData });
                                    }else{
                                        clearStateSpecific("delivery_filter");
                                    }
                                }}
                            />
                        </Grid>
                        :null}
                        {
                        hidePackage ? 
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                {...selectPackageAvailedProps}
                                autoComplete
                                includeInputInList
                                className={classes.autoComplete}
                                name="package_filter"
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Package Availed"
                                        margin="normal"
                                        variant="outlined"
                                        required="true"
                                    />
                                )}
                                onChange={async(event, newValue) => {
                                    if (
                                        !newValue == "" ||
                                        !newValue == null
                                    ) {
                                        const newData = {
                                            ...prep_data
                                        };
                                        newData["package_filter"] =
                                            JSON.stringify(
                                                newValue.id,
                                                null,
                                                " "
                                            );
                                        setData({ ...newData });
                                    }else{
                                        clearStateSpecific("package_filter");
                                    }
                                }}
                            />
                        </Grid>
                        :null}
                        {
                        hidePromo ? 
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                {...selectPromocodeProps}
                                autoComplete
                                includeInputInList
                                className={classes.autoComplete}
                                name="promo_filter"
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label="Promo Code"
                                        margin="normal"
                                        variant="outlined"
                                        required="true"
                                    />
                                )}
                                onChange={async(event, newValue) => {
                                    if (
                                        !newValue == "" ||
                                        !newValue == null
                                    ) {
                                        const newData = {
                                            ...prep_data
                                        };
                                        newData["promo_filter"] = newValue.nav_code;
                                        setData({ ...newData });
                                    }else{
                                        clearStateSpecific("promo_filter");
                                    }
                                }}
                            />
                        </Grid>
                        :null}
                        <Grid item xs={12} sm={3}>
                            <Button 
								variant="contained" 
								color="primary"
                                className={classes.btnSearch}
								onClick={(e) => {
									package_sales_summary();
								}}>
								Search
							</Button>
                        </Grid>
                    </Grid>
                <Grid item xs={12} style={{marginTop:"10px"}}>
                { 
                    !isLoaded ?  <Preloader /> :										
                    <MUIDataTable
                        title={
                            <div>
                                <div className="table-title">
                                    Package Sales Transaction History
                                </div>
                            </div>
                        }
                        id="table-grid"
                        data={TABLE_DATA}
                        columns={TABLE_COLUMNS}
                        options={TABLE_OPTION}
                    />
                }
                </Grid>
			</div>
            </LoadingOverlay>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <h4 id="transition-modal-title">System Message</h4>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        Are you sure you want to release this package?
                                    </Grid>
                                </Grid>
                                <div className={classes.button}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={2}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose}
                                            className={classes.buttonMarginRight}
                                        >
                                            No
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <Button 
                                            variant="contained" 
                                            color="primary"
                                            onClick={(e) => {releasepackage(releaseidno);handleClose();}}
                                        >
                                            Yes
                                        </Button>
                                    </Grid>
                                    </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open2}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open2}>
                        <div className={classes.paper}>
                            <h4 id="transition-modal-title">Choose Transaction First to Proceed</h4>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <Button
                                                variant="contained"
                                                className={classes.buttonMarginRight}
                                                onClick={set_package_encoding}
                                            >
                                                Set Package
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Button
                                                variant="contained"
                                                className={classes.buttonMarginRight}
                                                onClick={cyop_encoding}
                                            >
                                                Choose Your Own Package
                                        </Button>
                                    </Grid>
                                </Grid>
                                <div className={classes.button}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose2}
                                            className={classes.buttonMarginRight}
                                            style={{backgroundColor:"red",color:"white",float:'right',marginTop:"10px"}}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
		</div>
	);
};

export default PackageSalesSummary;